var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('map-filters',{attrs:{"given-top-level-filter":_vm.waterTypeFilter,"given-checkbox-groups":_vm.checkboxGroups},on:{"change":_vm.updateFilters}})}
var staticRenderFns = []

export { render, staticRenderFns }